document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelector<HTMLElement>('.tab-wrapper');

  if (tabs) {
    tabs.addEventListener('click', (e: Event) => {
      const target = e.target as HTMLElement;
      const id = target.dataset.id;

      if (id) {
        const tabButtons = document.querySelectorAll<HTMLElement>('.tab-button');
        const contents = document.querySelectorAll<HTMLElement>('.content');

        tabButtons.forEach((btn) => {
          btn.classList.remove('active');
        });
        target.classList.add('active');

        contents.forEach((content) => {
          content.classList.remove('active');
        });

        const element = document.getElementById(id);
        if (element) {
          element.classList.add('active');
        }
      }
    });
  }
});
